import { paymentStore } from '../store/paymentStore';

// Simple global event system for payment modal
class PaymentEventManager {
  openPaymentModal(paymentData) {
    paymentStore.openModal(paymentData);
  }

  closePaymentModal() {
    paymentStore.closeModal();
  }

  // Legacy method for backward compatibility
  subscribe(callback) {
    return paymentStore.subscribe((state) => {
      if (state.isOpen) {
        callback({ type: 'OPEN_MODAL', data: state.paymentData });
      } else {
        callback({ type: 'CLOSE_MODAL' });
      }
    });
  }
}

export const paymentEvents = new PaymentEventManager();